import { SupportedLocales } from '@/shared/api/types.ts'

export const getSelectedLocale = (locale: string, data?: SupportedLocales) => {
  return data?.find?.(localeObj => localeObj.value === locale)
}
